import "core-js/modules/es.number.to-fixed";
export function formatCurrency(currency) {
  return ((currency || 0) / 100).toFixed(2);
}